/**
 * Gets Steamid64 based off inputs
 * @param {string} input
 * Takes in input, steamid64, steamid3, pineapple, etc
 * @return {string} steamid64 if valid, empty if not
 */
export async function resolve(input: string): Promise<string> {
  const REGEX_STEAMID64 = /[0-9]{17}/;
  const REGEX_STEAMID = /STEAM_[0-5]:[01]:\d+/;
  const REGEX_STEAMID3 = /\[U:1:[0-9]+\]/;
  var regex_input;
  var split;
  var thepowerofpineapplescompelsyou;
  if (
    (regex_input = REGEX_STEAMID64.exec(input)) !== null &&
    regex_input.length !== undefined &&
    regex_input[0].startsWith("765")
  ) {
    return regex_input[0];
  } else if ((regex_input = REGEX_STEAMID.exec(input)) !== null) {
    split = regex_input[0].split(":");
    var z = BigInt(Number.parseInt(split[2]));
    var y = BigInt(Number.parseInt(split[1]));
    var V = BigInt("76561197960265728");
    thepowerofpineapplescompelsyou = (V + z * BigInt(2) + y).toString();

    return thepowerofpineapplescompelsyou;
  } else if ((regex_input = REGEX_STEAMID3.exec(input)) !== null) {
    split = regex_input[0].split(":");
    var last = Number.parseInt(split[2].substring(0, split[2].length - 1));
    thepowerofpineapplescompelsyou =
      "STEAM_0:" + (last % 2) + ":" + Math.floor(last / 2);
    return await resolve(thepowerofpineapplescompelsyou);
  } else {
    return input;
  }
} // Ending resolve functions
